import { render, staticRenderFns } from "./Tenancy.vue?vue&type=template&id=bc55ce52&scoped=true&"
import script from "./Tenancy.vue?vue&type=script&lang=js&"
export * from "./Tenancy.vue?vue&type=script&lang=js&"
import style0 from "./Tenancy.vue?vue&type=style&index=0&id=bc55ce52&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc55ce52",
  null
  
)

export default component.exports